import { yupBoolean, yupNumber, yupObject, yupPeriodicValue, yupString } from '../../yup';

/**
 * Validation schema for ERHL retirement details — non-retired applicants.
 * Covers retirement planning questions shown when employment status is NOT "Retired".
 */
export const createErhlRetirementDetailsSchema = (currentAge: number) =>
  yupObject({
    plannedRetirementAge: yupNumber()
      .integer('Age must be a whole number')
      .min(18, 'Age must be at least 18')
      .test(
        'above-current-age',
        "Retirement age must be higher than the applicant's current age",
        (value) => value === undefined || value > currentAge,
      )
      .required()
      .label('Planned retirement age'),

    incomeChangesBeforeRetirement: yupBoolean().required().label('This question'),

    incomeChangesBeforeRetirementDescription: yupString()
      .when('incomeChangesBeforeRetirement', {
        is: true,
        then: (schema) => schema.required(),
      })
      .label('Expected income change'),

    retirementIncomeImpact: yupString().required().label('Retirement impact'),

    expectedRetirementIncome: yupPeriodicValue(yupNumber().required().min(0, 'Amount is required')).label(
      'Expected retirement income',
    ),
  });

/**
 * Validation schema for ERHL retirement details — retired applicants (rows 140-141).
 * Covers financial changes question shown when employment status IS "Retired".
 */
export const erhlRetiredFinancialChangesSchema = yupObject({
  financialChangesDuringLoan: yupBoolean().required().label('This question'),

  financialChangesDuringLoanDescription: yupString()
    .when('financialChangesDuringLoan', {
      is: true,
      then: (schema) => schema.required(),
    })
    .label('Financial changes description'),
});
